module.exports = __webpack_public_path__ + "static/media/Asaas-wizard-details.2fa6b146.svg";